import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import { segmentedTabsContainer, segmentedTab } from '../../theme/designTokens';

// ============= セグメントコントロール型Tabs =============
const CustomTabs = styled(Tabs)(({ theme }) => ({
  ...segmentedTabsContainer('job_posting'),
}));

const CustomTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    ...segmentedTab('job_posting'),
  })
);

function NiceTabsExample({ tabValue, setTabValue }) {
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <CustomTabs
      value={tabValue}
      onChange={handleTabChange}
      variant="fullWidth"
      textColor="inherit"
      indicatorColor="secondary"
    >
      <CustomTab label="求人要件" />
      <CustomTab label="生成された求人票" />
    </CustomTabs>
  );
}

export default NiceTabsExample; 